import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appActions } from '../../../store';
import ProductList from '../../shared/ProductList/ProductList';
import styles from './StartPage.module.css';

export default function StartPage() {
    const dispatch = useDispatch();
    const chosenPattern = useSelector(state => state.app.chosenPattern);
    const [patternSearchTerm, setPatternSearchTerm] = useState('');

    const handlePatternSelect = (product) => {
        dispatch(appActions.setChosenPattern(product));
        dispatch(appActions.setStyle(product.name || product.color || 'Selected'));
        dispatch(appActions.setSize(product.descriptor || '18x18')); // Set size from pattern descriptor
        dispatch(appActions.setProductSelection([-1, -1]));
        dispatch(appActions.setCurrentView('swatch'));
    };

    // Don't render if pattern is already chosen
    if (chosenPattern) return null;

    return (
        <div className={styles.startPage}>
            <div className={styles.header}>
                <p className={styles.subtitle}>Let's Start Visualizing</p>
                <h1 className={styles.title}>Select your pattern to begin</h1>
            </div>
            <div className={styles.searchWrapper}>
                <input
                    type="text"
                    placeholder="Pattern name or SKU (e.g., Traditional, PXMH-001)"
                    value={patternSearchTerm}
                    onChange={(e) => setPatternSearchTerm(e.target.value)}
                    className={styles.searchInput}
                />
                <span className={styles.searchIcon} aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                        <line x1="16.65" y1="16.65" x2="21" y2="21" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </span>
            </div>
            <div className={styles.patternGrid}>
                <ProductList 
                    seriesId="9756"
                    thumbSize="256"
                    titleAttribute="name"
                    descriptionAttribute="description"
                    sortBy="name"
                    sortOrder="asc"
                    searchValue={patternSearchTerm}
                    searchColumns={['name', 'description','sku']}
                    onProductSelect={handlePatternSelect}
                    gridClassName={styles.fullWidthGrid}
                />
            </div>
        </div>
    );
}
